import {Component, inject, Input, OnInit} from '@angular/core';
import {LanguageService} from "@signature-it/ngx-generic/services";

@Component({
    selector: 'lang-filter',
    templateUrl: './lang-filter.html',
    styleUrls: ['./lang-filter.scss'],
    standalone: false
})
export class LangFilterComponent implements OnInit {

    @Input() lang: string;
    langSvc: LanguageService = inject(LanguageService);
    currentLangCode;

    ngOnInit() {
        this.initCurrentLangCode()
    }

    initCurrentLangCode(){
        let langDTO =  this.langSvc.getCurrentLanguage();
        this.currentLangCode = langDTO.code;
    }
}
